<template>
  <a-modal
    :visible="visible"
    :title="modalTitle"
    :width="1100"
    :footer="null"
    :body-style="{ padding: '16px 20px', maxHeight: '70vh', overflowY: 'auto', overflowX: 'hidden' }"
    @cancel="handleClose"
  >
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="24">
          <a-col :md="8" :sm="24">
            <a-form-item label="Start Time">
              <a-input v-model="queryParam.beginTime" placeholder="Please enter start time" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="End Time">
              <a-input v-model="queryParam.endTime" placeholder="Please enter end time" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="Weekday">
              <a-select v-model="queryParam.weekDay" placeholder="Please select weekday" allow-clear>
                <a-select-option v-for="day in weekOptions" :key="day" :value="day">{{ day }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :md="24" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleQuery"><a-icon type="search" />Search</a-button>
              <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />Reset</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operations">
      <a-button type="primary" @click="$refs.createForm.handleAdd(currentPitchId)" v-hasPermi="['golf:pitch/price:add']">
        <a-icon type="plus" />Add
      </a-button>
      <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['golf:pitch/price:remove']">
        <a-icon type="delete" />Delete
      </a-button>
    </div>

    <create-form ref="createForm" :pitch-id="currentPitchId" @ok="getList" />

    <a-table
      :loading="loading"
      :size="tableSize"
      rowKey="id"
      :columns="columns"
      :data-source="list"
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      :scroll="{ x: 980 }"
      :pagination="false"
      :bordered="tableBordered"
    >
      <span slot="createTime" slot-scope="text, record">
        {{ parseTime(record.createTime) }}
      </span>
      <span slot="operation" slot-scope="text, record">
        <a-divider type="vertical" v-hasPermi="['golf:pitch/price:edit']" />
        <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['golf:pitch/price:edit']">
          <a-icon type="edit" />Edit
        </a>
        <a-divider type="vertical" v-hasPermi="['golf:pitch/price:remove']" />
        <a @click="handleDelete(record)" v-hasPermi="['golf:pitch/price:remove']">
          <a-icon type="delete" />Delete
        </a>
      </span>
    </a-table>

    <a-pagination
      class="ant-table-pagination"
      show-size-changer
      show-quick-jumper
      :current="queryParam.pageNum"
      :total="total"
      :page-size="queryParam.pageSize"
      :showTotal="total => `Total ${total} items`"
      @showSizeChange="onShowSizeChange"
      @change="changeSize"
    />
  </a-modal>
</template>

<script>
import { pagePitchPrice, delPitchPrice } from '@/api/golf/pitchPrice'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'PitchPrice',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    pitchId: {
      type: [String, Number],
      default: null
    },
    pitchName: {
      type: String,
      default: ''
    }
  },
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      single: true,
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      queryParam: {
        beginTime: null,
        endTime: null,
        prices: null,
        sort: null,
        weekDay: null,
        pageNum: 1,
        pageSize: 10
      },
      weekOptions: [1, 2, 3, 4, 5, 6, 7],
      columns: [
        {
          title: 'Start Time',
          dataIndex: 'beginTime',
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'End Time',
          dataIndex: 'endTime',
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'Price',
          dataIndex: 'prices',
          ellipsis: true,
          align: 'center'
        },

        {
          title: 'Sort (Ascending)',
          dataIndex: 'sort',
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'Weekday',
          dataIndex: 'weekDay',
          ellipsis: true,
          align: 'center'
        },

        {
          title: 'Actions',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  computed: {
    currentPitchId () {
      return this.pitchId
    },
    modalTitle () {
      return this.pitchName ? `Pitch Pricing - ${this.pitchName}` : 'Pitch Pricing'
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.queryParam.pageNum = 1
        this.getList()
      }
    },
    pitchId () {
      if (this.visible) {
        this.queryParam.pageNum = 1
        this.getList()
      }
    }
  },
  methods: {
    handleClose () {
      this.$emit('close')
    },
    getList () {
      if (!this.currentPitchId) {
        this.list = []
        this.total = 0
        return
      }
      this.loading = true
      pagePitchPrice({
        ...this.queryParam,
        pitchId: this.currentPitchId
      }).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery () {
      this.queryParam = {
        beginTime: undefined,
        endTime: undefined,
        prices: undefined,
        sort: undefined,
        weekDay: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: 'Confirm deletion of selected data?',
        content: 'Selected IDs: ' + ids,
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delPitchPrice(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                'Deleted successfully',
                3
              )
          })
        },
        onCancel () {
          that.ids = []
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.ant-table-pagination {
  margin-top: 14px;
  margin-bottom: 0;
  text-align: right;
  padding-right: 4px;
}

/deep/ .ant-pagination-options {
  margin-left: 8px;
}
</style>
